export default __webpack_public_path__ + "static/media/icons8-docker (1).6123b8de.svg";